import { Expose } from "class-transformer";
import { Model } from "./model";

export class NameTranslationsModel extends Model {
    @Expose() ar: string; 
    @Expose() en: string; 
}